export function fmt(n: number): string {
  return n.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export const fmtAmt = fmt

export function maskCurrency(digits: string): string {
  if (!digits) return ''
  const padded = digits.padStart(3, '0')
  const cents  = padded.slice(-2)
  const reais  = padded.slice(0, -2).replace(/^0+/, '') || '0'
  return `${reais.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${cents}`
}

export function digitsToAmount(digits: string): number {
  return Number(digits) / 100
}

export function amountToDigits(amount: number): string {
  return Math.round(amount * 100).toString()
}
